export default "__VITE_ASSET__CzHgmjeX__"